// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectSecondary_root__3O_Pj","vLegacy":"SelectSecondary_vLegacy__1Ya_b","error":"SelectSecondary_error__3GeBy","disabled":"SelectSecondary_disabled__2_9tj"};